import { BarChart, CreditCard, HelpCircle, Star, TrendingUp } from "lucide-react";
import { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  ArrowLeft,
  Bell,
  BoxArrowRight,
  Building,
  Calendar,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  BarChart as DashboardIcon,
  Gear,
  Shield,
} from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import "../../assets/css/vendors/HotelComponents/hotelSidebar.css";
import AppContext from "../../context/AppContext";
import logo from "../../assets/images/logo.jpg"; 

const SETTINGS_KEYS = ["settings", "profile-settings", "notification-settings"];

const HotelSidebar = ({
  isMobile,
  isSidebarOpen,
  isCollapsed,
  onClose,
  onToggle,
}) => {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { baseUrl, activeSidebar, storeActiveSidebar, vendorloggedin, isUserLoggedIn } = useContext(AppContext);
  
  const [isSettingsOpen, setIsSettingsOpen] = useState(
    SETTINGS_KEYS.includes(activeSidebar)
  );

  const handleNavigation = (path, tab) => {
    if (!isUserLoggedIn()) {
      navigate('/auth/login');
      return;
    }
    storeActiveSidebar(tab);
    navigate(path);
    if (isMobile) onClose();
  };

  const handleSettingsToggle = (e) => {
    e.stopPropagation();
    if (isCollapsed && !isMobile) {
      onToggle();
      setIsSettingsOpen(true);
    } else {
      setIsSettingsOpen((prev) => !prev);
    }
  };

 const isSettingsActive = SETTINGS_KEYS.includes(activeSidebar);
 const {authToken,setAuthToken}=useContext(AppContext);
  useEffect(()=>{
    console.log("-----------------ndwnfsnn------");
    const token=localStorage.getItem("authToken");
    setAuthToken(token);
    console.log(authToken);
  },[]);

  useEffect(() => {
    if (SETTINGS_KEYS.includes(activeSidebar)) {
      setIsSettingsOpen(true);
    }
  }, [activeSidebar]);

  useEffect(() => {
    const checkAuth = () => {
      if (!isUserLoggedIn()) {
        navigate('/auth/login');
      }
    };
    checkAuth();
  }, [navigate, isUserLoggedIn]);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleLogoutConfirm = () => {
  localStorage.removeItem("vendorEmail");
  localStorage.removeItem("vendorPassword");
  localStorage.removeItem("vendorName");
  localStorage.removeItem("vendorRole");
  localStorage.removeItem("vendorId");
  localStorage.removeItem("authToken");
  localStorage.removeItem("userRole");
  localStorage.removeItem("hotelId");
    vendorloggedin();
    setShowLogoutModal(false);
    navigate('/auth/login');
  };

  const cancelLogout = () => setShowLogoutModal(false);

  if (!isUserLoggedIn()) {
    return null;
  }

  return (
    <>
      <aside
        className={`vhotel-sidebar-wrapper 
          ${!isMobile && isCollapsed ? "vhotel-collapsed" : ""} 
          ${isSidebarOpen ? "vhotel-open" : ""}`}
      >
        {/* HEADER */}
        <div className="vhotel-sidebar-header">
          {(!isCollapsed || isMobile) && (
            <button
              className="vhotel-sidebar-back-btn"
              onClick={() => navigate('/')}
            >
              <ArrowLeft size={16} />
              <span>Back</span>
            </button>
          )}

          <div className="vhotel-logo-container">
            {(isCollapsed && !isMobile) && (
              <img
                src={logo}
                alt="Journey Junction"
                className="vhotel-collapsed-logo"
              />
            )}

            {(!isCollapsed || isMobile) && (
              <div className="vhotel-logo-expanded">
                <img
                  src={logo}
                  alt="Journey Junction"
                  className="vhotel-brand-logo"
                />
                <div className="vhotel-logo-text-wrapper">
                  <h3 className="vhotel-logo-text">Journey Junction</h3>
                  <p className="vhotel-logo-subtitle">Hotel Panel</p>
                </div>
              </div>
            )}
          </div>
        </div>

        <nav className="vhotel-sidebar-nav">
          <div className="vhotel-sidebar-menu">

            {/* Dashboard */}
            <button
              onClick={() => handleNavigation("/vendor/hotel-dashboard", "dashboard")}
              className={`vhotel-menu-item ${activeSidebar === "dashboard" ? "vhotel-active" : ""}`}
            >
              <span className="vhotel-menu-icon"><DashboardIcon size={20} /></span>
              {(!isCollapsed || isMobile) && <span className="vhotel-menu-text">Dashboard</span>}
            </button>

            {/* Rooms */}
            <button
              onClick={() => handleNavigation("/vendor/hotel-rooms", "rooms")}
              className={`vhotel-menu-item ${activeSidebar === "rooms" ? "vhotel-active" : ""}`}
            >
              <span className="vhotel-menu-icon"><Building size={20} /></span>
              {(!isCollapsed || isMobile) && <span className="vhotel-menu-text">Rooms</span>}
            </button>

            {/* Bookings */}
            <button
              onClick={() => handleNavigation("/vendor/hotel-bookings", "bookings")}
              className={`vhotel-menu-item ${activeSidebar === "bookings" ? "vhotel-active" : ""}`}
            >
              <span className="vhotel-menu-icon"><Calendar size={20} /></span>
              {(!isCollapsed || isMobile) && <span className="vhotel-menu-text">Bookings</span>}
            </button>

            {/* Notifications */}
            <button
              onClick={() => handleNavigation("/vendor/hotel-notification", "notifications")}
              className={`vhotel-menu-item ${activeSidebar === "notifications" ? "vhotel-active" : ""}`}
            >
              <span className="vhotel-menu-icon"><Bell size={20} /></span>
              {(!isCollapsed || isMobile) && <span className="vhotel-menu-text">Notification</span>}
            </button>
            
            {/* Earnings */}
            <button
              onClick={() => handleNavigation("/vendor/hotel-earnings", "earnings")}
              className={`vhotel-menu-item ${activeSidebar === "earnings" ? "vhotel-active" : ""}`}
            >
              <span className="vhotel-menu-icon"><TrendingUp size={20} /></span>
              {(!isCollapsed || isMobile) && <span className="vhotel-menu-text">Earnings</span>}
            </button>

            {/* Reviews */}
            <button
              onClick={() => handleNavigation("/vendor/hotel-reviews", "reviews")}
              className={`vhotel-menu-item ${activeSidebar === "reviews" ? "vhotel-active" : ""}`}
            >
              <span className="vhotel-menu-icon"><Star size={20} /></span>
              {(!isCollapsed || isMobile) && <span className="vhotel-menu-text">Reviews</span>}
            </button>

            {/* Help and Support */}
            <button
              onClick={() => handleNavigation("/vendor/hotel-help-support", "help-support")}
              className={`vhotel-menu-item ${activeSidebar === "help-support" ? "vhotel-active" : ""}`}
            >
              <span className="vhotel-menu-icon"><HelpCircle size={20} /></span>
              {(!isCollapsed || isMobile) && <span className="vhotel-menu-text">Help & Support</span>}
            </button>

            {/* SETTINGS DROPDOWN */}
            <div className="vhotel-settings-dropdown">
              <button
                onClick={handleSettingsToggle}
                className={`vhotel-menu-item vhotel-settings-toggle ${isSettingsActive ? "vhotel-active" : ""}`}
              >
                <span className="vhotel-menu-icon"><Gear size={20} /></span>
                {(!isCollapsed || isMobile) && (
                  <>
                    <span className="vhotel-menu-text">Settings</span>
                    <span className="vhotel-dropdown-arrow">
                      {isSettingsOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                    </span>
                  </>
                )}
              </button>

              {isSettingsOpen && (!isCollapsed || isMobile) && (
                <div className="vhotel-submenu">
                  <button
                    onClick={(e) => { e.stopPropagation(); handleNavigation("/vendor/settings/hotel-settings", "settings"); }}
                    className={`vhotel-submenu-item ${activeSidebar === "settings" ? "vhotel-submenu-active" : ""}`}
                  >
                    <span className="vhotel-submenu-icon"><Gear size={16} /></span>
                    <span className="vhotel-submenu-label">Hotel Settings</span>
                  </button>

                  <button
                    onClick={(e) => { e.stopPropagation(); handleNavigation("/vendor/settings/hotel-profile-settings", "profile-settings"); }}
                    className={`vhotel-submenu-item ${activeSidebar === "profile-settings" ? "vhotel-submenu-active" : ""}`}
                  >
                    <span className="vhotel-submenu-icon"><Shield size={16} /></span>
                    <span className="vhotel-submenu-label">Profile Settings</span>
                  </button>

                  <button
                    onClick={(e) => { e.stopPropagation(); handleNavigation("/vendor/settings/notification-settings", "notification-settings"); }}
                    className={`vhotel-submenu-item ${activeSidebar === "notification-settings" ? "vhotel-submenu-active" : ""}`}
                  >
                    <span className="vhotel-submenu-icon"><Bell size={16} /></span>
                    <span className="vhotel-submenu-label">Notification Settings</span>
                  </button>
                </div>
              )}
            </div>

            <div className="vhotel-logout-item">
              <button onClick={handleLogoutClick} className="vhotel-logout-btn">
                <span className="vhotel-logout-icon"><BoxArrowRight size={20} /></span>
                {(!isCollapsed || isMobile) && (
                  <span className="vhotel-logout-text">Logout</span>
                )}
              </button>
            </div>

          </div>
        </nav>

        {/* TOGGLE BUTTON */}
       <div className="vhotel-sidebar-toggle-btn">
  <button onClick={onToggle} className="vhotel-toggle-btn">
    {isCollapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
  </button>
</div>
      </aside>

      <Modal
        show={showLogoutModal}
        onHide={cancelLogout}
        centered
        backdrop="static"
        className="vhotel-logout-modal"
      >
        <Modal.Header closeButton className="border-0 p-4 pb-0">
          <Modal.Title className="w-100 text-center">
            <div className="text-warning mb-2">
              <BoxArrowRight size={48} />
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center px-4 pb-3">
          <h5 className="fw-bold mb-3">Confirm Logout</h5>
          <p className="text-muted mb-0">
            Are you sure you want to logout?
          </p>
        </Modal.Body>

        <Modal.Footer className="border-0 justify-content-center pt-0 pb-4">
          <Button variant="outline-secondary" onClick={cancelLogout} className="px-4">
            Cancel
          </Button>
          <Button variant="danger" onClick={handleLogoutConfirm} className="px-4">
            <BoxArrowRight size={18} className="me-2" />
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default HotelSidebar;